// Lightweight helper to defer loading heavy Stimulus controllers until
// the matching data-controller appears in the DOM. This keeps the main
// application bundle smaller and only downloads the extra code when needed.
export function lazyLoadController(application, identifier, loader) {
  let registered = false

  const loadIfPresent = () => {
    if (registered) return
    if (!document.querySelector(`[data-controller~="${identifier}"]`)) return

    registered = true
    loader().then((module) => {
      const ControllerClass = module.default || module
      application.register(identifier, ControllerClass)
    })
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadIfPresent, { once: true })
  } else {
    loadIfPresent()
  }

  // Turbo navigation replaces the body, so re-check on each visit.
  document.addEventListener("turbo:load", loadIfPresent)

  // Lazy/eager turbo frames fetch their content separately and fire
  // `turbo:frame-load` (not `turbo:load`). A controller can live entirely
  // inside such a frame, so re-check when any frame finishes loading.
  document.addEventListener("turbo:frame-load", loadIfPresent)
}
